import { useState } from "react";

const FiuProcess = () => {
  const [activeTab, setActiveTab] = useState("step-one");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <>
      <div className="fiu-process-row">
        <div className="fiu-process-outer">
          {/* left */}
          <div className="fiu-process-left">
            <ul className="fiu-process-list">
              <li
                className={`fiu-process-links ${
                  activeTab === "step-one" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-one")}
              >
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-one" ? "active" : ""
                    }`}
                  >
                    Step 01
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-one" ? "active" : ""
                      }`}
                    >
                      Preliminary Consultation
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-one" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li
                className={`fiu-process-links ${
                  activeTab === "step-two" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-two")}
              >
                {" "}
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-two" ? "active" : ""
                    }`}
                  >
                    Step 02
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-two" ? "active" : ""
                      }`}
                    >
                      Risk Assessment
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-two" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li
                className={`fiu-process-links ${
                  activeTab === "step-three" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-three")}
              >
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-three" ? "active" : ""
                    }`}
                  >
                    Step 03
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-three" ? "active" : ""
                      }`}
                    >
                      Documentation Preparation
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-three" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li
                className={`fiu-process-links ${
                  activeTab === "step-four" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-four")}
              >
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-four" ? "active" : ""
                    }`}
                  >
                    Step 04
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-four" ? "active" : ""
                      }`}
                    >
                      Application Submission
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-four" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li
                className={`fiu-process-links ${
                  activeTab === "step-five" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-five")}
              >
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-five" ? "active" : ""
                    }`}
                  >
                    Step 05
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-five" ? "active" : ""
                      }`}
                    >
                      Compliance Audit
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-five" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li
                className={`fiu-process-links ${
                  activeTab === "step-six" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-six")}
              >
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-six" ? "active" : ""
                    }`}
                  >
                    Step 06
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-six" ? "active" : ""
                      }`}
                    >
                      Registration Approval
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-six" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li
                className={`fiu-process-links ${
                  activeTab === "step-five" ? "active" : ""
                }`}
                onClick={() => handleTabClick("step-seven")}
              >
                <div className="fiu-left-content-wrap">
                  <span
                    className={`fiu-left-content-title text-nowrap ${
                      activeTab === "step-seven" ? "active" : ""
                    }`}
                  >
                    Step 07
                  </span>
                  <div className="fiu-left-content-flex">
                    <h6
                      className={`fiu-left-content-title ${
                        activeTab === "step-seven" ? "active" : ""
                      }`}
                    >
                      Ongoing Compliance
                    </h6>
                    <span
                      className={`fiu-process-arrow ${
                        activeTab === "step-seven" ? "active" : ""
                      }`}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/*  right */}
          <div className="fiu-process-right process-right-none">
            <div
              className="tools_rt_inner process-right-lists"
              id="tools_rt_scroll"
            >
              {/* step-one */}
              <div
                id="step-one"
                className={`techstack_content ${
                  activeTab === "step-one" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-one.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Preliminary Consultation</h6>
                      <p>
                        The process begins with a consultation to understand
                        your business and its compliance needs. During this
                        stage, a roadmap is prepared.
                      </p>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* step-two */}
              <div
                id="step-two"
                className={`techstack_content ${
                  activeTab === "step-two" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-two.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Risk Assessment</h6>
                      <p>
                        Consultants evaluate potential risks associated with
                        your business model and suggest measures to mitigate
                        them.
                      </p>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* step-three */}
              <div
                id="step-three"
                className={`techstack_content ${
                  activeTab === "step-three" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-three.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Documentation Preparation</h6>
                      <ul className="process-unordered">
                        Comprehensive documentation is prepared, including:
                        <li>Business registration documents</li>
                        <li>AML/CTF policies</li>
                        <li>Details of key personnel</li>
                        <li>Financial statements</li>
                      </ul>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* step-four */}
              <div
                id="step-four"
                className={`techstack_content ${
                  activeTab === "step-four" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-four.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Application Submission</h6>
                      <p>
                        The completed application is submitted to FIU-IND for
                        review. Consultants ensure that all requirements are met
                        to avoid delays.
                      </p>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* step-five */}
              <div
                id="step-five"
                className={`techstack_content ${
                  activeTab === "step-five" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-five.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Compliance Audit</h6>
                      <p>
                        FIU-IND may conduct audits or inspections. Consultants
                        assist in preparing for these audits, ensuring your
                        business is compliant.
                      </p>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* step-six */}
              <div
                id="step-six"
                className={`techstack_content ${
                  activeTab === "step-six" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-six.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Registration Approval</h6>
                      <p>
                        Once the application is approved, the FIU Registration
                        is issued, allowing your business to operate legally.
                      </p>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* step-seven*/}
              <div
                id="step-seven"
                className={`techstack_content ${
                  activeTab === "step-seven" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="process-right-content">
                    <div>
                      <img
                        src={require("../../../image/fiu/step-seven.webp")}
                        alt="FIU Consultant"
                      />
                      <h6>Ongoing Compliance</h6>
                      <p>
                        Post-license, regular compliance checks and updates are
                        necessary to maintain the license. Consultants provide
                        continuous support in this phase.
                      </p>
                    </div>

                    <div>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="process-right-btn"
                      >
                        Get Consultation
                      </button>
                      <span className="mx-2 process-right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* mobile accordian (It will visible max-width:768px) */}
          <div className="fiu-process-right process-right-mobile">
            <div
              className="tools_rt_inner process-right-lists"
              id="tools_rt_scroll"
            >
              <div id="step-one">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-one")}
                >
                  <div>
                    <span className="fiu-left-content-title">Step 01</span>
                    <span className="fiu-left-content-title mx-3">
                      Preliminary Consultation
                    </span>
                  </div>
                </div>

                {activeSection === "step-one" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-one.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Preliminary Consultation</h6>
                        <p>
                          The process begins with a consultation to understand
                          your business and its compliance needs. During this
                          stage, a roadmap is prepared.
                        </p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div id="step-two">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-two")}
                >
                  <span className="fiu-left-content-title">Step 02</span>
                  <span className="fiu-left-content-title mx-3">
                    Risk Assessment
                  </span>
                </div>

                {activeSection === "step-two" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-two.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Risk Assessment</h6>
                        <p>
                          Consultants evaluate potential risks associated with
                          your business model and suggest measures to mitigate
                          them.
                        </p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div id="step-three">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-three")}
                >
                  <span className="fiu-left-content-title">Step 03</span>
                  <span className="fiu-left-content-title mx-3">
                    Documentation Preparation
                  </span>
                </div>
                {activeSection === "step-three" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-three.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Documentation Preparation</h6>
                        <ul className="process-unordered">
                          Comprehensive documentation is prepared, including:
                          <li>Business registration documents</li>
                          <li>AML/CTF policies</li>
                          <li>Details of key personnel</li>
                          <li>Financial statements</li>
                        </ul>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div id="step-four">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-four")}
                >
                  <span className="fiu-left-content-title">Step 04</span>
                  <span className="fiu-left-content-title mx-3">
                    Application Submission
                  </span>
                </div>

                {activeSection === "step-four" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-four.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Application Submission</h6>
                        <p>
                          The completed application is submitted to FIU-IND for
                          review. Consultants ensure that all requirements are
                          met to avoid delays.
                        </p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div id="step-five">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-five")}
                >
                  <span className="fiu-left-content-title">Step 05</span>
                  <span className="fiu-left-content-title mx-3">
                    {" "}
                    Compliance Audit
                  </span>
                </div>

                {activeSection === "step-five" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-five.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Compliance Audit</h6>
                        <p>
                          FIU-IND may conduct audits or inspections. Consultants
                          assist in preparing for these audits, ensuring your
                          business is compliant.
                        </p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div id="step-six">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-six")}
                >
                  <span className="fiu-left-content-title">Step 06</span>
                  <span className="fiu-left-content-title mx-3">
                    {" "}
                    Registration Approval
                  </span>
                </div>

                {activeSection === "step-six" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-six.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Registration Approval</h6>
                        <p>
                          Once the application is approved, the FIU Registration
                          is issued, allowing your business to operate legally.
                        </p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div id="step-seven">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("step-seven")}
                >
                  <span className="fiu-left-content-title">Step 07</span>
                  <span className="fiu-left-content-title mx-3">
                    Ongoing Compliance
                  </span>
                </div>

                {activeSection === "step-seven" && (
                  <div className="tools-accordion-body">
                    <div className="process-right-content">
                      <div>
                        <img
                          src={require("../../../image/fiu/step-seven.webp")}
                          alt="FIU Consultant"
                        />
                        <h6>Ongoing Compliance</h6>
                        <p>
                          Post-license, regular compliance checks and updates
                          are necessary to maintain the license. Consultants
                          provide continuous support in this phase.
                        </p>
                      </div>

                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#myModal"
                          className="process-right-btn"
                        >
                          Get Consultation
                        </button>
                        <span className="mx-2 process-right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FiuProcess;
